import styled from 'styled-components';

export const CellContent = styled.div.attrs<{ className?: string }>({ className: 'table-cell-content' })`
  margin: 0;

  p {
    margin: 0;
  }
`;
